import { combineReducers } from 'redux';
import reservationsDetails from './reservationsDetails';
import reservationsCheckout from './reservationsCheckout';
import reservationsWidget from './reservationsWidget';
import reservationsManagerHistory from './reservationsManagerHistory';
import reservationsManagerWidget from './reservationsManagerWidget';
import reservationsGlobalSearch from './reservationsGlobalSearch';
import reservationsList from './reservationsList';

const reservationsModule = combineReducers({
  reservationsDetails,
  reservationsCheckout,
  reservationsWidget,
  reservationsManagerHistory,
  reservationsManagerWidget,
  reservationsGlobalSearch,
  reservationsList,
});

export default reservationsModule;
